module.exports = __webpack_public_path__ + "img/icon-smartwatch-green-success.8a7aa46a.svg";